import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { InterestLayers } from '@/constants/diagnoses'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'

interface InterestLayersTotals {
  min: number
  max: number
}

interface IResults {
  mean: number
  std: number
}

interface Summary {
  layers: InterestLayers[]
  totals: Partial<Record<InterestLayers, InterestLayersTotals>>
  fields: {
    name: string
    layers: Partial<Record<InterestLayers, IResults>>
  }[]
}

type GetPhysiologicalDiagnosesItem = {
  id: string
  project: {
    id: string
    name: string
  }
  mosaic: {
    date: string
  }
  state_acr: string
  culture: Culture
  phenological_stage: string
  cicle: string
  summary: Summary | null
  status: {
    name: string
    status_key: string
    description: string
    label: string
  }
  concluded_at: string
}

export const getPhysiologicalDiagnosisById = async (
  id: string,
  options?: AxiosRequestConfig,
) => {
  const { data } = await companiesApi.get<GetPhysiologicalDiagnosesItem>(
    apiRoutes.getPhysiologicalDiagnosisById('soybean', id),
    {
      ...options,
    },
  )

  return data
}
